import type React from "react";
import Table from "app/pages/workspace/sales/components/custom-table/Table/Table";
import { StyledTable } from "./styles";
import { EmptySearchState } from "../common/EmptySearchState/EmptySearchState";
import { useExportTableService } from "../../hooks/useExportTableService";
import { SelectedCell } from "./cells/SelectedCell";
import { SimilarwebCell } from "./cells/SimilarwebCell";
import type { FieldsTableProps } from "./type";

export const FieldsTable: React.FC<FieldsTableProps> = ({
    onSelect,
    onPreDefinedChange,
    onPreDefinedCreateChange,
    onPreDefinedUpdateChange,
    onTechnographicsChange,
    data,
    numOfPreDefined,
    numOfPreDefinedCreate,
    numOfPreDefinedUpdate,
    numOfTechnographics,
    exportName,
}) => {
    const exportTableService = useExportTableService(exportName);

    return (
        <StyledTable>
            <Table
                reactsToMouseEnter
                data={data}
                columns={exportTableService.getSettingsColumns()}
                customRenderers={{
                    similarweb: (entry) => <SimilarwebCell entry={entry} />,
                    selected: (entry) => (
                        <SelectedCell
                            entry={entry}
                            numOfPreDefined={numOfPreDefined}
                            numOfPreDefinedCreate={numOfPreDefinedCreate}
                            numOfPreDefinedUpdate={numOfPreDefinedUpdate}
                            numOfTechnographics={numOfTechnographics}
                            onPreDefinedChange={onPreDefinedChange}
                            onPreDefinedCreateChange={onPreDefinedCreateChange}
                            onPreDefinedUpdateChange={onPreDefinedUpdateChange}
                            onTechnographicsChange={onTechnographicsChange}
                            onSelect={onSelect}
                        />
                    ),
                }}
                emptyState={<EmptySearchState />}
            />
        </StyledTable>
    );
};
